

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { CRACreditSetup } from "../../components/CRACreditSetup";


export const CRACreditSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="CRA Credit"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "CRA Credit", navigateTo: "/taxes/remittance/cra" },
      ]}
      mainContents={<CRACreditSetup />}
    />
  );
};
